"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var BookTable = function BookTable(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "BookTable"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "book-table"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.76 17.76h16.48c0.42 0 0.76-0.34 0.76-0.76s-0.34-0.76-0.76-0.76v0h-0.24v-1c-0.003-3.705-2.524-6.821-5.944-7.727l-0.056-0.013c0.151-0.294 0.24-0.641 0.24-1.009 0-1.237-1.003-2.24-2.24-2.24s-2.24 1.003-2.24 2.24c0 0.368 0.089 0.715 0.246 1.021l-0.006-0.013c-3.476 0.919-5.997 4.035-6 7.74v0.94h-0.24c-0.42 0-0.76 0.34-0.76 0.76s0.34 0.76 0.76 0.76v0zM9.24 6.5c-0-0.006-0-0.013-0-0.020 0-0.42 0.34-0.76 0.76-0.76s0.76 0.34 0.76 0.76c0 0.42-0.34 0.76-0.76 0.76h-0c-0 0-0 0-0 0-0.413 0-0.749-0.329-0.76-0.739l-0-0.001zM19.24 18.5h-18.48c-0.037-0.006-0.079-0.010-0.123-0.010-0.42 0-0.76 0.34-0.76 0.76s0.34 0.76 0.76 0.76c0.043 0 0.086-0.004 0.127-0.011l-0.004 0.001h18.48c0.364-0.061 0.637-0.374 0.637-0.75s-0.274-0.689-0.633-0.749l-0.004-0.001zM17.14 6.74s0 0 0 0c0.1-0.841 0.759-1.5 1.591-1.599l0.009-0.001s0 0 0 0c-0.847-0.101-1.509-0.771-1.599-1.612l-0.001-0.008s0 0 0 0c-0.1 0.841-0.759 1.5-1.591 1.599l-0.009 0.001s0 0 0 0c0.847 0.101 1.509 0.771 1.599 1.612l0.001 0.008zM2.86 7.98v0c0.067-0.592 0.543-1.054 1.136-1.1l0.004-0s0 0 0 0c-0.603-0.047-1.082-0.52-1.14-1.115l-0-0.005s0 0 0 0c-0.072 0.576-0.524 1.028-1.094 1.099l-0.006 0.001s0 0 0 0c0.586 0.066 1.045 0.532 1.1 1.115l0 0.005zM4.98 4.48s0 0 0 0c0.121-1.105 0.954-1.986 2.025-2.178l0.015-0.002cv-0.1c-1.072-0.219-1.885-1.1-1.999-2.189l-0.001-0.011s0 0 0 0c-0.123 1.092-0.934 1.964-1.984 2.177l-0.016 0.003cv0.1c1.058 0.228 1.857 1.108 1.959 2.19l0.001 0.010z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = BookTable;
exports["default"] = _default;